/* eslint-disable import/prefer-default-export */

import { fetchWp } from './core';

async function fetchMedia({ path, query }) {
  return fetchWp({ path: `media/${path}`, query });
}

export function fetchImage(id) {
  return fetchMedia({ path: id });
}
